import React, { Component, PropTypes } from 'react';
import {
  StyledDisclaimerWrapper,
  StyledDisclaimerContent,
  StyledDisclaimerText,
  StyledDisclaimerButton,
  StyledModalOverlay,
  StyledDisclaimerImage
} from './styles';

/**
 * Disclaimer appears on click of indicator image and is removed/hidden when the user
 * clicks off of the disclaimer. Content is sent in as a child of the Disclaimer container.
 */
class Disclaimer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    indicatorImg: PropTypes.string,
    classNames: PropTypes.string
  }
  static defaultProps = {
    indicatorImg: undefined,
    classNames: ''
  }
  constructor(props) {
    super(props);
    this.disclaimerHandler = this.disclaimerHandler.bind(this);
    this.renderIndicator = this.renderIndicator.bind(this);
  }
  state = {
    opened: false,
  }
  disclaimerHandler(event) {
    event.preventDefault();
    this.setState({ opened: !this.state.opened });
  }
  renderIndicator() {
    const { indicatorImg } = this.props;
    if (!indicatorImg) {
      return '*';
    }
    return (
      <StyledDisclaimerImage alt="" src={indicatorImg} className="info-disclaimer" />
    )
  }
  render() {
    const { children, classNames } = this.props;
    const { opened } = this.state;
    const totalClasses = `pe-disclaimer ${classNames}`
    return (
      <StyledDisclaimerWrapper className="disclaimer-wrapper">
        <StyledDisclaimerButton onClick={this.disclaimerHandler} aria-describedby="disclaimer-content" className={totalClasses}>
          {this.renderIndicator()}
        </StyledDisclaimerButton>
        <StyledDisclaimerContent className="disclaimer-content" aria-hidden={!opened}>
          <StyledModalOverlay className="modal-overlay" onClick={this.disclaimerHandler} />
          <StyledDisclaimerText className="disclaimer-text" dangerouslySetInnerHTML={{ __html: children }} />
        </StyledDisclaimerContent>
      </StyledDisclaimerWrapper>
    )
  }
}

export default Disclaimer;



/** WEBPACK FOOTER **
 ** ./src/components/Disclaimer/index.js
 **/